import { render, staticRenderFns } from "./buy_vipDialog.vue?vue&type=template&id=bee5a9fc&"
import script from "./buy_vipDialog.vue?vue&type=script&lang=js&"
export * from "./buy_vipDialog.vue?vue&type=script&lang=js&"
import style0 from "./buy_vipDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports